var _circle, _path, _rect, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWatchLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 174,
    viewBox: "0 0 180 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 87,
    r: 87,
    fill: "url(#paint0_linear_14725_122308)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1076 54.6877L25 51.2465L16.3123 47.8843L12.7758 38L9.3278 47.6368L0 51.2465L9.53249 54.9352L12.7758 64L16.1076 54.6877Z",
    fill: "#BDC3C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 10.3125,
    width: 94.1586,
    height: 132.296,
    rx: 2,
    transform: "rotate(-0.801501 43 10.3125)",
    fill: "#ADB9BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1958 136.795C54.2239 137.187 54.5545 137.489 54.9478 137.481L130.954 135.928C131.343 135.92 131.66 135.612 131.677 135.222L132.302 121.065C132.306 120.987 132.297 120.909 132.276 120.834L129.982 112.604C129.881 112.239 129.519 112.01 129.146 112.074L54.0189 124.968C53.6446 125.032 53.38 125.369 53.407 125.748L54.1958 136.795Z",
    fill: "#8E9EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.297 13.853L50.3318 15.0383C49.2274 15.0549 48.3455 15.9637 48.362 17.0681L50.0966 132.622C50.1132 133.727 51.022 134.609 52.1264 134.592L131.092 133.407C132.196 133.39 133.078 132.481 133.062 131.377L131.327 15.8228C131.31 14.7183 130.402 13.8364 129.297 13.853Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8203,
    y: 27.9766,
    width: 39.5221,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 71.8203 27.9766)",
    fill: "#BDC3C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3281,
    y: 42.2793,
    width: 66.5087,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 58.3281 42.2793)",
    fill: "#BDC3C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3281,
    y: 52.8887,
    width: 66.5087,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 58.3281 52.8887)",
    fill: "#BDC3C8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3281,
    y: 63.4961,
    width: 66.5087,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 58.3281 63.4961)",
    fill: "#BDC3C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3281,
    y: 74.1055,
    width: 66.5087,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 58.3281 74.1055)",
    fill: "#BDC3C8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3281,
    y: 84.7148,
    width: 66.5087,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 58.3281 84.7148)",
    fill: "#BDC3C8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3281,
    y: 95.3223,
    width: 66.5087,
    height: 3.69365,
    rx: 1,
    transform: "rotate(-0.866421 58.3281 95.3223)",
    fill: "#BDC3C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14725_122308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.036 25.9057C177.972 25.356 179.178 25.6683 179.728 26.6115C180.277 27.5485 179.965 28.754 179.022 29.3037L177.31 30.3032C177.06 30.4531 176.711 30.4343 176.323 30.2095C175.549 29.7722 174.918 28.6916 174.918 27.8046C174.918 27.3611 175.068 27.0488 175.318 26.8989L177.029 25.8994L177.036 25.9057Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.922 27.8161C174.922 27.3726 175.072 27.0603 175.322 26.9104L177.033 25.911C177.645 25.5549 178.364 25.5612 178.945 25.8673C178.42 25.6799 177.608 26.1608 176.658 26.7168C175.709 27.2727 175.247 27.9661 176.009 29.4027C176.565 30.4459 177.196 30.3334 177.502 30.196L177.314 30.3085C177.064 30.4584 176.715 30.4396 176.327 30.2148C175.553 29.7775 174.922 28.6969 174.922 27.8099V27.8161Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.952 25.8432C171.863 24.138 175.611 25.1124 177.323 28.0295C179.028 30.9403 178.054 34.6882 175.136 36.3997C174.356 36.8557 173.275 36.7994 172.076 36.1186C169.677 34.7569 167.722 31.415 167.703 28.6604C167.697 27.2799 168.172 26.3117 168.952 25.8557V25.8432Z",
    fill: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.012 26.1251C174.411 27.4868 176.366 30.8287 176.384 33.5833C176.391 34.9638 175.916 35.932 175.135 36.388L137.488 58.4566C136.707 58.9125 135.627 58.8563 134.427 58.1755C132.029 56.8138 130.073 53.4719 130.055 50.7173C130.049 49.3368 130.523 48.3686 131.304 47.9126L168.951 25.844C169.732 25.388 170.813 25.4443 172.012 26.1251Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.012 26.1251C174.411 27.4868 176.366 30.8287 176.384 33.5833C176.391 34.9638 175.916 35.932 175.135 36.388L137.488 58.4566C136.707 58.9125 135.627 58.8563 134.427 58.1755C132.029 56.8138 130.073 53.4719 130.055 50.7173C130.049 49.3368 130.523 48.3686 131.304 47.9126L168.951 25.844C169.732 25.388 170.813 25.4443 172.012 26.1251Z",
    fill: "#C5CCD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.691 51.9586C127.71 54.7945 129.721 58.23 132.189 59.6292C133.419 60.3288 134.531 60.3913 135.337 59.9228L138.229 58.2237C139.029 57.7553 139.522 56.7558 139.51 55.3379C139.491 52.502 137.48 49.0665 135.012 47.6673C133.782 46.9677 132.67 46.9052 131.87 47.3737L128.978 49.0728C128.179 49.5412 127.685 50.5407 127.698 51.9586H127.691Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.691 51.9586C127.71 54.7945 129.721 58.23 132.189 59.6292C133.419 60.3288 134.531 60.3913 135.337 59.9228L138.229 58.2237C139.029 57.7553 139.522 56.7558 139.51 55.3379C139.491 52.502 137.48 49.0665 135.012 47.6673C133.782 46.9677 132.67 46.9052 131.87 47.3737L128.978 49.0728C128.179 49.5412 127.685 50.5407 127.698 51.9586H127.691Z",
    fill: "#D4D9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.619 57.0313C136.601 54.1954 134.589 50.7599 132.122 49.3607C130.891 48.6611 129.78 48.5986 128.98 49.0671C128.18 49.5356 127.687 50.535 127.699 51.9529C127.718 54.7888 129.73 58.2243 132.197 59.6235C133.427 60.3231 134.539 60.3856 135.345 59.9171C136.145 59.4486 136.638 58.4492 136.626 57.0313H136.619Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.619 57.0313C136.601 54.1954 134.589 50.7599 132.122 49.3607C130.891 48.6611 129.78 48.5986 128.98 49.0671C128.18 49.5356 127.687 50.535 127.699 51.9529C127.718 54.7888 129.73 58.2243 132.197 59.6235C133.427 60.3231 134.539 60.3856 135.345 59.9171C136.145 59.4486 136.638 58.4492 136.626 57.0313H136.619Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.289 79.4876C100.983 79.0816 101.408 78.2133 101.401 76.989C101.383 74.5342 99.6398 71.5609 97.5098 70.3428C96.4417 69.7369 95.4797 69.687 94.7864 70.093L93.3747 71.4672C92.9187 71.8982 92.6501 72.604 92.6564 73.541C92.6688 75.8022 94.2742 78.5444 96.2418 79.6625C97.0538 80.1247 97.8034 80.2309 98.3968 80.0435L100.283 79.4876H100.289Z",
    fill: "#BA68C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.289 79.4876C100.983 79.0816 101.408 78.2133 101.401 76.989C101.383 74.5342 99.6398 71.5609 97.5098 70.3428C96.4417 69.7369 95.4797 69.687 94.7864 70.093L93.3747 71.4672C92.9187 71.8982 92.6501 72.604 92.6564 73.541C92.6688 75.8022 94.2742 78.5444 96.2418 79.6625C97.0538 80.1247 97.8034 80.2309 98.3968 80.0435L100.283 79.4876H100.289Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4 76.9819C101.381 74.5271 99.6386 71.5538 97.5086 70.3357C96.4405 69.7298 95.4785 69.6798 94.7852 70.0859L128.741 50.1848C129.434 49.7788 130.396 49.8287 131.464 50.4346C133.6 51.6464 135.343 54.626 135.356 57.0808C135.362 58.3114 134.937 59.1734 134.244 59.5794L100.288 79.4805C100.982 79.0745 101.406 78.2062 101.4 76.9819Z",
    fill: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2441 71.6415C93.8625 71.2605 94.7308 71.3042 95.699 71.8602C97.6104 72.947 99.1657 75.6268 99.172 77.838C99.172 78.9311 98.8034 79.7057 98.185 80.068C98.185 80.068 98.1726 80.0805 98.1663 80.0805C95.9863 81.3485 89.4338 83.7846 86.2044 83.4098L86.1669 83.3536C86.0108 83.3411 85.8421 83.2911 85.6672 83.1912C84.9614 82.7852 84.3867 81.7982 84.3867 80.9737C84.3867 80.7801 84.4242 80.6114 84.4867 80.4802C85.7422 77.457 91.1141 72.9033 93.2629 71.6415H93.2441Z",
    fill: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.065 82.5295L84.6595 83.3541C84.0474 83.7163 82.3234 84.2785 82.036 83.7913C81.7487 83.3041 83.0854 82.0735 83.6976 81.7112L85.0968 80.8867C85.0968 80.8867 85.4528 80.9117 85.8338 81.5613C86.2149 82.2047 86.0587 82.5295 86.0587 82.5295H86.065Z",
    fill: "#5E6974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1683 83.1719C82.337 83.2094 82.4869 83.3093 82.5806 83.4717C82.6743 83.6341 82.6868 83.8153 82.6368 83.9777C82.3495 83.9964 82.1246 83.9402 82.0371 83.7903C81.9497 83.6404 82.0059 83.4155 82.1683 83.1719Z",
    fill: "#5E6974"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8158 110.14L95.6381 107.07C93.0518 108.256 91.0042 107.07 91.0042 107.07C91.0042 107.07 88.9567 108.256 86.3704 107.07L83.1953 110.14C83.1953 110.14 85.0273 112.348 84.2178 114.666C83.4108 116.982 82.872 119.353 84.0022 121.453C85.1324 123.553 88.0421 124.307 88.9042 124.415C89.7663 124.523 90.8965 125.816 90.8965 125.816C90.8965 125.816 92.2422 124.523 93.1043 124.415C93.9664 124.307 96.8761 123.553 98.0063 121.453C99.1365 119.353 98.5976 116.982 97.7907 114.666C96.9838 112.351 98.8132 110.14 98.8132 110.14H98.8158Z",
    fill: "#BDC3C8",
    stroke: "#ADB9BF",
    strokeWidth: 0.397779,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1719 115.256L91.1495 116.497L89.9196 114.855L87.1719 115.256Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1484 116.497L92.3784 114.855L95.1261 115.256L91.1484 116.497Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1484 116.497L93.1373 117.194L95.1261 115.256L91.1484 116.497Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1495 116.497L89.1607 117.194L87.1719 115.256L91.1495 116.497Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.148 112.365V116.498L89.918 114.856L91.148 112.365Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1484 112.365L92.3784 114.856L91.1484 116.498V112.365Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1496 116.496L88.6914 119.931L89.1607 117.194L91.1496 116.496Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1496 116.496V118.638L88.6914 119.931L91.1496 116.496Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1484 116.496L93.6066 119.931L91.1484 118.638V116.496Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1484 116.496L93.1373 117.194L93.6066 119.931L91.1484 116.496Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14725_122308",
    x1: 74,
    y1: -296,
    x2: 93,
    y2: 243.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14725_122308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 58.9786,
    fill: "white",
    transform: "translate(82 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWatchLists);
export default __webpack_public_path__ + "static/media/no-watch-lists.37815dbbde417a68113ff1889366a6f5.svg";
export { ForwardRef as ReactComponent };